
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

interface LoadMoreButtonProps {
  hasMoreMessages: boolean;
  isLoadingMore: boolean;
  onLoadMore: () => Promise<boolean>;
}

export const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  hasMoreMessages,
  isLoadingMore,
  onLoadMore
}) => {
  const { t } = useTranslation();
  
  const handleLoadMore = async () => {
    if (isLoadingMore) return;
    await onLoadMore();
  };
  
  if (!hasMoreMessages) {
    return null;
  }
  
  return (
    <div className="flex justify-center pt-2">
      <Button
        variant="outline"
        size="sm"
        onClick={handleLoadMore}
        disabled={isLoadingMore}
        className={cn(
          "text-xs h-7 px-3 leading-none",
          isLoadingMore && "opacity-70"
        )}
      >
        {isLoadingMore ? (
          <span className="flex items-center gap-1.5">
            <span className="h-3 w-3 animate-spin rounded-full border-2 border-gray-300 border-t-gray-600"></span>
            <span className="font-normal">{t('ai_assistant.loading_more')}</span>
          </span>
        ) : (
          <span className="flex items-center gap-1.5">
            <ArrowUp className="h-3 w-3" />
            <span className="font-normal">{t('ai_assistant.load_more')}</span>
          </span>
        )}
      </Button>
    </div>
  );
};
